import { useEffect, useRef, useState } from 'react'
import PubSub from 'pubsub-js'

function useFixedNavObserve({
  getMarkNode,
}: {
  getMarkNode(): HTMLElement | null
}) {
  const observerRef = useRef<IntersectionObserver>()
  const [isFixed, setIsFixed] = useState(false)

  const [markNode, setMarkNode] = useState<HTMLElement | null>(null)

  useEffect(() => {
    setMarkNode(getMarkNode())
  }, [getMarkNode])

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (changes) => {
        changes.forEach((change) => {
          if (change.isIntersecting || change.boundingClientRect.bottom < 0) {
            setIsFixed(true)
            PubSub.publish('SEARCH_INPUT_Hidden', true)
          } else {
            setIsFixed(false)
            PubSub.publish('SEARCH_INPUT_Hidden', false)
          }
        })
      },
      {
        rootMargin: '10000px 0px -100% 0px',
      }
    )
  }, [])

  useEffect(() => {
    if (!markNode || !observerRef.current) return

    const observer = observerRef.current

    observer.observe(markNode)

    return () => {
      observer.disconnect()
    }
  }, [markNode])

  return isFixed
}

export default useFixedNavObserve
